"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = Expandable;
var React = _interopRequireWildcard(require("react"));
var _Slide = _interopRequireDefault(require("../../../utils/Slide"));
var _useBoundingRect = _interopRequireDefault(require("../../../hooks/useBoundingRect"));
function Expandable({
  expanded,
  children,
  slideID
}) {
  const [{
    height
  }, ref] = (0, _useBoundingRect.default)({
    height: expanded ? null : 0
  });
  return /*#__PURE__*/React.createElement(_Slide.default, {
    maxHeight: height,
    expanded: expanded,
    id: slideID
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children));
}